
(() => {
  const BAG_HANDLE = 'dark-matter-surf-bags';
  const GIFT_ID = 45632393117780;
  const GIFT_PROPERTY = '_dark_matter_free_gift';
  const GIFT_VALUE = 'surf_bag_promotion';

  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const nativeXHRSend = XMLHttpRequest.prototype.send;

  let syncing = false;
  let pending = false;
  let refreshVersion = 0;
  let debounceTimer;

  const apiUrl = path => root + path;

  async function api(path, options = {}) {
    const response = await nativeFetch(apiUrl(path), options);
    if (!response.ok) {
      throw new Error(`Gift API error: ${response.status}`);
    }
    return response.json();
  }

  async function getCart() {
    return api('cart.js');
  }

  async function updateGift(key, quantity) {
    return api('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }

  async function addGift() {
    return api('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: GIFT_ID,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: GIFT_VALUE
          }
        }]
      })
    });
  }

  async function refreshDrawer() {
    const version = ++refreshVersion;

    const response = await nativeFetch(
      `${root}?sections=cart-drawer,cart-icon-bubble`,
      { cache: 'no-store' }
    );

    if (!response.ok) {
      throw new Error('Unable to load cart sections');
    }

    const sections = await response.json();
    if (version !== refreshVersion) return;

    const drawer = document.querySelector('cart-drawer');

    if (drawer && sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const updated = doc.querySelector('#CartDrawer');
      const current = drawer.querySelector('#CartDrawer');

      if (updated && current) {
        current.innerHTML = updated.innerHTML;
      }
    }

    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const updated = doc.querySelector('#cart-icon-bubble');
      const current = document.querySelector('#cart-icon-bubble');

      if (updated && current) {
        current.innerHTML = updated.innerHTML;
      }
    }

    const cart = await getCart();

    if (version !== refreshVersion) return;

    if (drawer) {
      drawer.classList.toggle(
        'is-empty',
        cart.item_count === 0
      );

      drawer.querySelector('.drawer__inner')?.classList.toggle(
        'is-empty',
        cart.item_count === 0
      );
    }
  }

  async function syncGift() {
    if (syncing) {
      pending = true;
      return;
    }

    syncing = true;

    try {
      do {
        pending = false;

        const cart = await getCart();
        const bagQuantity = cart.items
  .filter(item => item.handle === BAG_HANDLE)
  .reduce((total, item) => total + item.quantity, 0);

        const gifts = cart.items.filter(
          item =>
            item.properties?.[GIFT_PROPERTY] === GIFT_VALUE
        );

        let changed = false;

        if (bagQuantity > 0 && gifts.length === 0) {
  await addGift();
  changed = true;

  if (bagQuantity > 1) {
    const updatedCart = await getCart();

    const gift = updatedCart.items.find(
      item =>
        item.properties?.[GIFT_PROPERTY] === GIFT_VALUE
    );

    if (gift) {
      await updateGift(gift.key, bagQuantity);
    }
  }
} else {
  for (let i = 0; i < gifts.length; i++) {
    const desired = i === 0 ? bagQuantity : 0;

    if (gifts[i].quantity !== desired) {
      await updateGift(gifts[i].key, desired);
      changed = true;
    }
  }
}

        if (changed) {
          await refreshDrawer();
        }
      } while (pending);

    } catch (error) {
      console.error('Dark Matter free gift:', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncGift, 100);
  }

  function isCartMutation(url, method) {
    return method !== 'GET' &&
      /\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url);
  }

  // Watch fetch-based cart updates.
  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);

    const input = args[0];
    const url = String(input?.url || input);
    const method = String(
      args[1]?.method || input?.method || 'GET'
    ).toUpperCase();

    if (response.ok && isCartMutation(url, method)) {
      scheduleSync();
    }

    return response;
  };

  // Dawn cart update events.
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleSync();
  });
})();
